import { countSocialCardReferences, deleteMedia, updateHappening } from '@littlebooker/dal';

/**
 * Write a show's generated card map, then remove the objects it replaced.
 *
 * The admin side does its own sweeping (the artist side gets it server-side, in
 * the public social-cards endpoint): a card re-rendered from a new crop lands
 * under a new URL, so without this the old file would sit in R2 forever. The
 * reference count guards the one case where a URL is not this show's alone — a
 * series whose episodes inherited the same map through an apply-to-future save.
 *
 * Counted AFTER the write, so the check already sees this show holding the new
 * URLs rather than the old ones.
 */
export async function saveShowSocialCards(
  happeningId: string,
  cards: Record<string, string>,
  previousCards: Record<string, string> = {},
): Promise<void> {
  await updateHappening(happeningId, { metadata: { social_cards: cards } });

  const kept = new Set(Object.values(cards));
  const replaced = new Set(
    Object.values(previousCards).filter((url) => url && !kept.has(url)),
  );
  for (const url of replaced) {
    if ((await countSocialCardReferences(url)) === 0) {
      await deleteMedia(url);
    }
  }
}
